import React, {useState} from 'react';
import Header from '../../components/auth/Header';
import Siderbar from '../../components/auth/Siderbar';
import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true)
  
  return (
    <>
    <Header isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen}/>
    <Siderbar isSidebarOpen={isSidebarOpen}/>
    <div id="main" class={`${isSidebarOpen ? 'main-spacing' : ''}`}>
    <div class="container-fluid">
        <div class="col-md-12 col-12">
    <Outlet />
    </div>
    </div>
    </div>
    </>
    // <div className='sb-nav-fixed'>
    //   <div className='row'>
    //     <div className='col-4'><Siderbar /></div>
    //     <div className='col-8'>
    //       <div className='header_container'>
    //       <Header />
    //       </div>
    //       <div className='main_contant'>
    //       <Outlet />
    //       </div>
    //       </div>
    //   </div>
    // </div>
  );
}
export default AuthLayout;